import React, { useState } from "react";
import Modal from './index';
import Input from '../Form/Input';
import FormGroup from "../Form/FormGroup";
import Button from "../Form/Button";
import { MdKey } from "react-icons/md";
import FormGroupInline from '../Form/FormGroupInline';
import Select from "../Form/Select";
import styles from "./modalApiToken.module.css";
import {
    API_TOKEN_ACCESS_OPTIONS,
    API_TOKEN_EXPIRATION_OPTIONS,
    API_TOKEN_SCOPE_OPTIONS,
    getApiTokenAccessOptionsForEdit,
    getApiTokenExpirationOptionsForEdit,
    getApiTokenScopeOptionsForEdit,
    getApiTokenFormValue,
} from "../../utils/apiTokens";

const environmentLabels = {
    live: "Produção",
    sandbox: "Sandbox",
}

const ModalApiToken = ({ value, editing = false, environments = ["live"], newToken, showNewToken, onSubmit, closeModal }) => {
    const [data, setData] = useState(getApiTokenFormValue(value, environments[0] || "live"))
    const environmentOptions = environments.map(environment => ({ id: environment, value: environmentLabels[environment] || environment }))
    const accessOptions = editing ? getApiTokenAccessOptionsForEdit(value) : API_TOKEN_ACCESS_OPTIONS
    const expirationOptions = editing ? getApiTokenExpirationOptionsForEdit(value) : API_TOKEN_EXPIRATION_OPTIONS
    const scopeOptions = editing ? getApiTokenScopeOptionsForEdit(value) : API_TOKEN_SCOPE_OPTIONS

    const handleChangeValue = (name, value) => {
        setData(previousValue => ({
            ...previousValue,
            [name]: value,
            ...(name === "access_mode" && value !== "custom" ? { scopes: [] } : {}),
        }))
    }

    const handleCancel = (e) => {
        e.preventDefault()
        closeModal()
    }

    return (
        <Modal
            icon={<MdKey />}
            title={showNewToken ? "Esse é o seu novo token" : editing ? "Editar credencial" : "Cadastro de novo token"}
            description={showNewToken ? "Por motivos de segurança não será possível visualizar esse token novamente! Salve ele em um local seguro, e não compartilhe com ninguém." : editing ? "Altere a identificação, reduza o acesso ou antecipe a expiração." : "Registre um novo token para utilizar em sua API."}
            closeModal={closeModal}
        >
            {!showNewToken &&
                <form onSubmit={(e) => onSubmit(e, data)}>
                    <FormGroup labelText="Identificação">
                        <Input type="text" placeholder="Identificação do token" value={data?.name ?? ""} onChange={(e) => handleChangeValue("name", e.target.value)} />
                    </FormGroup>
                    <FormGroup labelText="Ambiente">
                        <Select name="Ambiente" placeholder="Selecione um ambiente" multiple={false} disabled={editing} options={environmentOptions} selected={data?.environment ?? "live"} onChange={(value) => handleChangeValue("environment", value)} />
                    </FormGroup>
                    <FormGroup labelText="Nível de acesso">
                        <Select name="Nível de acesso" placeholder="Selecione o acesso" multiple={false} options={accessOptions} selected={data?.access_mode ?? "read_write"} onChange={(value) => handleChangeValue("access_mode", value)} />
                        <span className={styles.helper}>{data?.access_mode === "read_only" ? "Permite apenas consultas GET, HEAD e OPTIONS." : data?.access_mode === "custom" ? "Libere somente os recursos e operações necessários para esta integração." : "Permite consultas e alterações, sempre limitadas pelas permissões do seu cargo."}</span>
                    </FormGroup>
                    {data?.access_mode === "custom" &&
                        <FormGroup labelText="Escopos personalizados">
                            <Select name="Escopos" placeholder="Pesquise um recurso" multiple={true} showOptionAll={false} options={scopeOptions} selected={data?.scopes || []} onChange={(value) => handleChangeValue("scopes", value)} />
                            <span className={styles.helper}>Escrita também permite consultar o mesmo recurso. Ao editar, você pode remover escopos; para adicionar novos, gere outra credencial.</span>
                        </FormGroup>
                    }
                    <FormGroup labelText={editing ? "Antecipar expiração (opcional)" : "O token expira em"}>
                        <Select name={editing ? "Não alterar" : "Expira em"} placeholder="Pesquise uma opção" multiple={false} options={expirationOptions} selected={data?.expire_in ?? ""} onChange={(value) => handleChangeValue("expire_in", value)} />
                        {editing && <span className={styles.helper}>Para renovar ou ampliar a validade, gere um novo token e revogue o anterior.</span>}
                    </FormGroup>
                    <FormGroupInline>
                        <Button variant='primary' type="submit">Salvar</Button>
                        <Button variant='secondary' onClick={handleCancel}>Cancelar</Button>
                    </FormGroupInline>
                </form>
            }
            {showNewToken &&
                <FormGroup labelText="Token">
                    <span>{newToken ?? ""}</span>
                </FormGroup>
            }
        </Modal>
    )
}

export default ModalApiToken
